import { setStageGoal } from '@/store/modules/onboarding/routines'

export default {
  [setStageGoal.TRIGGER](state, payload) {
    state.stageGoal = payload
  }
}
